import React from 'react';
import { Button } from '@ais-ui/ui-core';
import { PiFunnel } from 'react-icons/pi';

interface FilterTriggerProps {
  activeFilterCount: number;
  className?: string;
  children?: React.ReactNode;
}

export const FilterTrigger = React.forwardRef<
  HTMLButtonElement,
  FilterTriggerProps
>(({ activeFilterCount, className = '', ...props }, ref) => {
  return (
    <div className="relative">
      <Button
        ref={ref}
        className={`h-10 w-10 ${className}`}
        variant="outline"
        size="icon"
        {...props}
      >
        <PiFunnel className="size-5" />
      </Button>
      {activeFilterCount > 0 && (
        <span className="absolute -top-2 -right-2.5 inline-flex items-center justify-center px-1 py-0.5 text-xs font-bold leading-none text-red-100 bg-primary rounded-full pointer-events-none z-10">
          {activeFilterCount}
        </span>
      )}
    </div>
  );
});

FilterTrigger.displayName = 'FilterTrigger';
